export enum QuestionState {
  REVIEW = 'REVIEW',
  ANSWERED = 'ANSWERED',
  PRESENTER = 'PRESENTER',
  PRIORITIZED = 'PRIORITIZED',
  REMOVED = 'REMOVED',
}

export enum SenderStatus {
  PRESENTER = 'PRESENTER',
  VIEWER = 'VIEWER',
  AI = 'AI'
}

export enum QandaTabs {
  UNANSWERED = 'Unanswered',
  ANSWERED = 'Answered',
  REMOVED = 'Removed',
  EMPTY = 'EMPTY',
}

export enum QnadaReviewModeTabs {
  FOR_REVIEW = 'For Review',
  PRIORITIZED = 'Prioritized',
  PRESENTER = 'Presenter',
}

export enum ActionButtonText {
  MARK_ANSWERED = 'Mark as Answered',
  MARK_REMOVED = 'Remove',
  MOVE_UNANSWERED = 'Move to Unanswered',
  MOVE_REVIEW = 'Move to Review'
}
